import React from 'react';

import Tooltip from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import runModal from 'ui-library/runModal';

import AddToWorklistModal from './AddToWorklistModal';
import {RefreshOptions} from './WorklistActions';
import {areIdsValidForWorklist, getWorklistType, idsToTooltipTitle} from './WorklistUtil';

export interface AddToWorklistButtonProps {
  buttonStyle: ButtonStyle;
  buttonSize?: ButtonSize;
  className?: string;
  disabled?: boolean;
  ids: Array<string>;
  refreshOptions: RefreshOptions;
  // This callback aims to track user clicks.
  onClickTracking?: () => void;
}

/**
 * Button to add items to a worklist. It auto-detects the worklist type based on the given ids.
 * It validates the ids to ensure they can be added to the same type of worklist, and is disabled otherwise.
 */
export default function AddToWorklistButton(props: AddToWorklistButtonProps): JSX.Element {
  const idsValid = areIdsValidForWorklist(props.ids);
  const disabled = props.disabled || !idsValid;

  function addToWorklist(): void {
    props.onClickTracking?.();
    runModal(AddToWorklistModal, {
      ids: props.ids,
      worklistType: getWorklistType(props.ids),
      refreshOptions: props.refreshOptions,
    });
  }

  return (
    <Tooltip title={idsToTooltipTitle(props.ids)}>
      <Button
        buttonStyle={props.buttonStyle}
        className={props.className}
        disabled={disabled}
        icon="worklist-add"
        onClick={addToWorklist}
        size={props.buttonSize || ButtonSize.SMALL}
        dataTestAttrs={{component: 'AddToWorklistsButton', element: 'button'}}
      />
    </Tooltip>
  );
}
